import React, { useEffect, useState } from "react";
import { Tab, Nav } from "react-bootstrap";
import axios from "axios";
import { useSelector } from "react-redux";
import Dropdown from "react-bootstrap/Dropdown";
import { CancelIcon, SearchesCIcon, SortIcon } from "../../../../SvgIconsData";
import Filter from "../../../Filter/Filter";
import { AZIcon, OldSortIcon, ZAIcon, CloseIcon } from "../../../../assets/icons/iconshere";
import CoursesCard from "./CoursesCard";

const Courses = () => {
  const [selectedCheckboxes, setSelectedCheckboxes] = useState([]);
  const appData = useSelector((state) => state.applicationSlice);
  const [search, setSearch] = useState("");
  const [optionList, setOptionList] = useState([]);
  const userData = useSelector((state) => state.userSlice);
  const configData = useSelector((state) => state.configSlice);
  const [loading, setLoading] = useState(true);
  const [list, setList] = useState([]);
  const [activeKey, setActiveKey] = useState("tostart");
  const [shorting, setShorting] = useState({
    status: true,
    value: (b, c) => new Date(c.createdAt) - new Date(b.createdAt),
    type: 1,
  });
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const selectedTags = selectedCheckboxes.map((item) => item.id);
  const [selectedCategoryCheckboxes, setSelectedCategoryCheckboxes] = useState([]);

  const handleSelect = (key) => {
    setActiveKey(key);
  };

  useEffect(() => {
      setOptionList(appData?.tags?.data?.children?.filter((e) => e?.name != "Sectors") || []);
  }, [appData?.categoryList]);

  const handleDropdownToggle = () => {
    setDropdownOpen(!dropdownOpen);
  };

  const getModuleList = async () => {
    try {
      const resData = await axios.get(`${configData.config.API_URL}/api/module/list/${configData.config.MODE}`, {
        params:{
         applicationId: configData.config.applicationId
        },
        headers: {
          Authorization: `Bearer ${userData.token}`,
        },
      });
      let moduleList = resData?.data?.data || [];

      setList([...moduleList]);
      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getModuleList();
  }, []);

  const filterCourses = (e) => {
    if (search.length && !e.name.toLowerCase().includes(search.toLowerCase())) return false;
    const tags = e.tags.map((e) => e.id);
    const tagCategory = e.tagCategory.map((e) => e.id);
    if (selectedTags.length && !selectedTags.some((element) => tags.includes(element))) return false;
    if (
      selectedCategoryCheckboxes.length &&
      !selectedCategoryCheckboxes.some((checkbox) => tagCategory.includes(checkbox.id))
    )
      return false;
    return true;
  };

  const handleCancelTag = (item) => {
    setSelectedCheckboxes((prevSelected) => prevSelected.filter((selectedItem) => selectedItem !== item));
    setSelectedCategoryCheckboxes((prevSelected) => prevSelected.filter((selectedItem) => selectedItem !== item));
  };

  let filteredList = list.filter(filterCourses);
  shorting.status && filteredList.sort(shorting.value);
  let onGoingProject = filteredList.filter((e) => e.progress !== 100 && e.progress > 0).length;
  let yetToStartProject = filteredList.filter((e) => e.progress === 0).length;
  let completedProject = filteredList.filter((e) => e.progress === 100 && e.progress > 0).length;

  const getCurrentTab = () => {
    let currentTab = activeKey;
    const activeTabCountChanged =
      (activeKey === "ongoing" && onGoingProject != 0) ||
      (activeKey === "completed" && completedProject != 0) ||
      (activeKey === "tostart" && yetToStartProject != 0);
    if (activeTabCountChanged) {
      currentTab = activeKey;
    } else {
      const counts = {
        ongoing: onGoingProject,
        completed: completedProject,
        tostart: yetToStartProject,
      };
      currentTab = Object.keys(counts).reduce((a, b) => (counts[a] > counts[b] ? a : b));
    }
    return currentTab;
  };

  useEffect(() => {
    let currentTab = getCurrentTab();
    setActiveKey(() => currentTab);
    // onGoingProject > 0 && setActiveKey("ongoing");
  }, [onGoingProject, yetToStartProject, completedProject]);

  return (
    <>
      <div className="container-fluid p-0">
        <div className="col-md-12">
          <Tab.Container id="my-tabs" activeKey={activeKey} onSelect={handleSelect}>
            <Nav className="tabsproduct updated toptab " variant="tabs">
              <Nav.Item>
                <Nav.Link eventKey="ongoing">
                  Ongoing{" "}
                  {!loading && onGoingProject > 0 && (
                    <>
                      {" "}
                      <span className="numbers">({onGoingProject}) </span>{" "}
                    </>
                  )}
                </Nav.Link>
              </Nav.Item>

              <Nav.Item>
                <Nav.Link eventKey="tostart">
                  Yet to start{" "}
                  {!loading && yetToStartProject > 0 && (
                    <>
                      {" "}
                      <span className="numbers">({yetToStartProject}) </span>{" "}
                    </>
                  )}
                </Nav.Link>
              </Nav.Item>

              <Nav.Item>
                <Nav.Link eventKey="completed">
                  Completed{" "}
                  {!loading && completedProject > 0 && (
                    <>
                      {" "}
                      <span className="numbers">({completedProject}) </span>{" "}
                    </>
                  )}
                </Nav.Link>
              </Nav.Item>
            </Nav>

            <div className="container-fluid p-4 pb-0 pt-5 bg-grey-main">
              <div className="divforrepo mt-2">
                <div />
                <div>
                  <form className=" app-search app-search1 d-flex justify-content-start ">
                    <div className="position-relative">
                      <SearchesCIcon />
                      {search.length > 0 && (
                        <span className="searchiconcancel" onClick={() => setSearch("")}>
                          <CancelIcon />
                        </span>
                      )}
                      <input
                        type="text"
                        name="searchName"
                        className="form-control"
                        placeholder="Search"
                        autoComplete="off"
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                      />
                    </div>
                  </form>

                  {list.length > 0 && (
                    <Filter
                      selectedCheckboxes={selectedCheckboxes}
                      setSelectedCheckboxes={setSelectedCheckboxes}
                      filterOptions={optionList}
                      categoryOptions={
                        (appData?.categoryList?.data?.length === 1
                          ? appData?.categoryList?.data[0]
                          : appData?.categoryList?.data) || null
                      }
                      selectedCategoryCheckboxes={selectedCategoryCheckboxes}
                      setSelectedCategoryCheckboxes={setSelectedCategoryCheckboxes}
                    />
                  )}

                  <Dropdown show={dropdownOpen} onToggle={handleDropdownToggle}>
                    <Dropdown.Toggle id="dropdown-basic" className="createbtn" style={{ width: "40px" }}>
                      {shorting.type == 1 ? (
                        <SortIcon />
                      ) : shorting.type == 2 ? (
                        <OldSortIcon />
                      ) : shorting.type == 3 ? (
                        <AZIcon />
                      ) : (
                        <ZAIcon />
                      )}
                    </Dropdown.Toggle>
                    <Dropdown.Menu className="sidebartopbar modulelistoptions sort">
                      <div className="listoptionsmodule">
                        <p
                          className={shorting.status && shorting.type == 1 ? "active" : ""}
                          onClick={() => {
                            setShorting({
                              status: true,
                              value: (b, c) => new Date(c.createdAt) - new Date(b.createdAt),
                              type: 1,
                            });
                            setDropdownOpen(false);
                          }}
                        >
                          {" "}
                          Latest{" "}
                        </p>
                        <p
                          className={shorting.status && shorting.type == 2 ? "active" : ""}
                          onClick={() => {
                            setShorting({
                              status: true,
                              value: (b, c) => new Date(b.createdAt) - new Date(c.createdAt),
                              type: 2,
                            });
                            setDropdownOpen(false);
                          }}
                        >
                          {" "}
                          Oldest{" "}
                        </p>
                        <p
                          className={shorting.status && shorting.type == 3 ? "active" : ""}
                          onClick={() => {
                            setShorting({ status: true, value: (b, c) => b.name.localeCompare(c.name), type: 3 });
                            setDropdownOpen(false);
                          }}
                        >
                          {" "}
                          Name ( A to Z){" "}
                        </p>
                        <p
                          className={shorting.status && shorting.type == 4 ? "active" : ""}
                          onClick={() => {
                            setShorting({ status: true, value: (b, c) => c.name.localeCompare(b.name), type: 4 });
                            setDropdownOpen(false);
                          }}
                        >
                          {" "}
                          Name ( Z to A){" "}
                        </p>
                      </div>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </div>

              <div className="row">
                <div className="col-6 d-flex align-items-center justify-content-start"></div>

                {[...selectedCheckboxes, ...selectedCategoryCheckboxes].length > 0 && (
                  <div className="filerlist mt-3">
                    <span>Filters:</span>
                    {[...selectedCheckboxes, ...selectedCategoryCheckboxes].map((f) => {
                      return (
                        <span className="filtertag">
                          {f.name}
                          <span onClick={() => handleCancelTag(f)}>
                            <CloseIcon />
                          </span>
                        </span>
                      );
                    })}
                    <span
                      className="filtertag clear"
                      onClick={() => {
                        setSelectedCheckboxes([]);
                        setSelectedCategoryCheckboxes([]);
                      }}
                      style={{ cursor: "pointer" }}
                    >
                      Clear all
                    </span>
                  </div>
                )}

                <Tab.Content>
                  <Tab.Pane eventKey="tostart">
                    <div className={selectedCheckboxes.length > 0 ? "filteractive" : ""}>
                      <CoursesCard
                        list={filteredList.filter((e) => e.progress === 0)}
                        page="myLearning"
                        loading={loading}
                      />
                    </div>
                  </Tab.Pane>

                  <Tab.Pane eventKey="ongoing">
                    <div className={selectedCheckboxes.length > 0 ? "filteractive" : ""}>
                      <CoursesCard
                        list={filteredList.filter((e) => e.progress !== 100 && e.progress > 0)}
                        page="myLearning"
                        loading={loading}
                      />
                    </div>
                  </Tab.Pane>

                  <Tab.Pane eventKey="completed">
                    <div className={selectedCheckboxes.length > 0 ? "filteractive" : ""}>
                      <CoursesCard
                        list={filteredList.filter((e) => e.progress === 100)}
                        page="myLearning"
                        loading={loading}
                      />
                    </div>
                  </Tab.Pane>
                </Tab.Content>
              </div>
            </div>
          </Tab.Container>
        </div>
      </div>
    </>
  );
};

export default Courses;
